// modifer: styles/jss/nextjs-material-kit-pro/pages/productStyle
import { section, container } from 'styles/jss/original/base';

const styles = {
  section: {
    ...section,
    padding: '0',
    '@media (max-width: 640px)': {
      padding: '0'
    }
  },
  container,
  flex: {
    display: 'flex'
  },
  textWrapper: {
    padding: '70px 0',
    textAlign: 'center',
    '@media (max-width: 640px)': {
      padding: '60px 0'
    }
  },
  imgLoading: {
    width: '128px'
  },
  shoppingList: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginBottom: '10px'
  }
};

export default styles;
